export const handleCopyClick = async (textToCopy, setCopyStatus) => {
    try {
        await navigator.clipboard.writeText(textToCopy);
        setCopyStatus(true);
        setTimeout(() => setCopyStatus(false), 2000); // Reset copy status after 2 seconds
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
};

export const handleShareClick = async (title, text, url) => {
    if (navigator.share) {
        try {
            await navigator.share({
                title: title,
                text: text,
                url: url
            });
        } catch (error) {
            console.error('Error sharing:', error);
        }
    } else {
        alert('Sharing not supported on this browser. Please copy the URL manually.');
    }
};
